import { Avatar, type AvatarProps, Flex } from '@chakra-ui/react'

import type { ProgressionLevel } from '@/queries/constants'
import { ACHIEVEMENT_ID_TO_DATA } from '@/client/services/progression'
import { getPublicUrl } from '@/client/services/url'

// Found empirically
const AVATAR_SCALE_PERCENTAGE = '78.225%'

export default function UserAvatar({
  progressionLevel,
  ...avatarProps
}: {
  progressionLevel: ProgressionLevel
} & Required<Pick<AvatarProps, 'size' | 'name' | 'src'>> &
  Omit<AvatarProps, 'size' | 'name' | 'src' | 'w' | 'h' | 'width' | 'height'>): JSX.Element {
  const frameUrl = `${getPublicUrl()}/avatarFrames/${progressionLevel}.svg`

  if (progressionLevel == null) {
    return <Avatar {...avatarProps} />
  }

  // If we're showing a frame, discard the border prop
  const { src: avatarSrc, name: avatarName, ...frameProps } = avatarProps

  return (
    <Flex align="center" justify="center">
      <Avatar
        bg="none"
        alignSelf="center"
        src={frameUrl}
        name={ACHIEVEMENT_ID_TO_DATA[progressionLevel].title}
        {...frameProps}
      >
        <Avatar
          src={avatarSrc}
          name={avatarName}
          alignSelf="center"
          position="absolute"
          width={AVATAR_SCALE_PERCENTAGE}
          height={AVATAR_SCALE_PERCENTAGE}
        />
      </Avatar>
    </Flex>
  )
}
